const navLinks = [
  { label: 'Our Brands', href: '#brands' },
  { label: 'About', href: '#about' },
  { label: 'Partnerships', href: '#partnerships' },
  { label: 'Careers', href: '#careers' },
  { label: 'Contact', href: '#contact' },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50 pt-16 pb-8 px-6 md:px-10">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-5">
            <div className="flex flex-col leading-none">
              <span className="font-heading text-2xl font-semibold tracking-[0.08em] text-background-50">JEDL</span>
              <span className="text-[10px] uppercase tracking-[0.42em] mt-1 text-background-50/60">Restaurants</span>
            </div>
            <p className="mt-6 font-heading text-lg text-background-50/80 italic">
              Restaurant concepts. Hospitality. Community.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.25em] text-background-50/40">Navigate</p>
            <ul className="mt-5 space-y-3">
              {navLinks.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="text-sm text-background-50/80 hover:text-background-50 transition-colors">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs uppercase tracking-[0.25em] text-background-50/40">Contact</p>
            <ul className="mt-5 space-y-3 text-sm text-background-50/80">
              <li>
                <a href="mailto:johan@jedlrestaurants.com" className="hover:text-background-50 transition-colors">
                  johan@jedlrestaurants.com
                </a>
              </li>
              <li>
                <a href="tel:+16192832663" className="hover:text-background-50 transition-colors">
                  (619) 283-2663
                </a>
              </li>
              <li className="leading-relaxed">
                5119 Cass St, San Diego, CA 92109-1812
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-background-50/50">© 2026 JEDL Restaurants LLC. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <a href="#top" className="text-xs text-background-50/60 hover:text-background-50 transition-colors">
              Privacy Policy
            </a>
            <a href="#top" className="text-xs text-background-50/60 hover:text-background-50 transition-colors">
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}